// extracted by mini-css-extract-plugin
module.exports = {"slugTitle":"new_slugTitle__3CmOi","footer":"new_footer__2imbm","hint":"new_hint__2OQUz"};